module.exports = __webpack_public_path__ + "static/media/George Mokhtar_Turner Townsend.b0e8af77.png";